import { useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCheck } from "@fortawesome/pro-solid-svg-icons";
import ScopeStackModal from "@components/ScopeStackModal/ScopeStackModal";

interface CopyFieldProps {
  label: string;
  value: string;
  copyable: boolean;
}

const CopyField = ({ label, value, copyable }: CopyFieldProps): JSX.Element => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{ marginBottom: "16px" }}>
      <label style={{ fontWeight: 600, display: "block", marginBottom: "4px" }}>
        {label}
      </label>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <code
          style={{
            flex: 1,
            padding: "8px",
            background: "#f5f5f5",
            borderRadius: "4px",
            overflowX: "auto",
            fontFamily: "monospace",
          }}
        >
          {value}
        </code>
        {copyable && (
          <Button variant="outline-secondary" size="sm" onClick={handleCopy}>
            <FontAwesomeIcon icon={copied ? faCheck : faCopy} />{" "}
            {copied ? "Copied" : "Copy"}
          </Button>
        )}
      </div>
    </div>
  );
};

interface Props {
  show: boolean;
  onClose: () => void;
  clientId?: string;
  clientSecret?: string;
  clientIdMasked?: boolean;
  warning?: string;
}

const RevealCredentialsModal = ({
  show,
  onClose,
  clientId,
  clientSecret,
  clientIdMasked = false,
  warning = "Save these now. You won't be able to view them again — only the secret can be rotated.",
}: Props): JSX.Element => {
  const body = (
    <>
      {clientId && (
        <CopyField
          label="Client ID"
          value={clientId}
          copyable={!clientIdMasked}
        />
      )}
      {clientSecret && (
        <CopyField label="Client Secret" value={clientSecret} copyable={true} />
      )}
      <div
        style={{
          background: "#fff3cd",
          border: "1px solid #ffeeba",
          padding: "12px",
          borderRadius: "4px",
          color: "#856404",
          marginTop: "8px",
        }}
      >
        {warning}
      </div>
    </>
  );

  return (
    <ScopeStackModal
      show={show}
      modalTitle="Save your credentials"
      modalBody={body}
      handleClose={onClose}
      button1Text=""
      handleButton1Click={() => {}}
      button2Text="I've saved these"
      handleButton2Click={onClose}
    />
  );
};

export default RevealCredentialsModal;
